<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'object-position',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Image Focus',
            message: '* may not have any effect, depending on the available container space',
            tailwindDefinitionProp: 'objectPosition',
            value: '',
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };
            const positionOptions = this.themeObjectValues.map(v => ({ value: v, text: this.titleCase(v) }));

            return [defaultOption].concat(positionOptions);
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            this.value = valueNew;

            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.addFlexClass({
                tailwindDefinitionProp: 'transformOrigin',
                key: getClassDefinition(flexClassNew).key,
            });

            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            let { value } = this.flexClassDefinition;

            if (!value) {
                value = this.getComputedValue();
            }

            if (this.themeObjectValues.includes(value)) {
                this.value = value;
            } else {
                this.value = '';
            }
        },
    },
};
</script>
